import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  getDefaultProps,
  MediaProp,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { BackgroundColors, Variants } from "@kameleon-util/global-theme";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

export type ContentCollectionItemType = {
  /** Place prop documentation here */
  _index?: number;
  tabTitle?: string;
  tagline?: string;
  title?: string;
  description?: string;
  image?: MediaProp;
} & PrimaryBlockType<LayoutProps>;

/** ContentCollectionItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
};

export const ContentCollectionItem = primaryBlock<ContentCollectionItemType>(
  blockConfig,
  ({
    SecondaryBlock,
    TertiaryBlock,
    _index,
    tabTitle,
    tagline,
    title,
    description,
    image,
    layoutProps,
  }: ContentCollectionItemType) => {
    const isBackgroundColorSameAsOdd =
      layoutProps.backgroundColor === BackgroundColors.neutralLight ||
      layoutProps.backgroundColor === BackgroundColors.darkest;
    const isOdd = (_index ?? 0) % 2 === 1;

    return (
      <Box className="primary-collection-content-collection-two-col-stacking-layouts-v1">
        <Box className="layout357_anchor" />
        <Variants.GridOddEven
          odd={isBackgroundColorSameAsOdd ? !isOdd : isOdd}
          className={`layout357_content-item content-item-${_index}`}
        >
          <Box className="padding-global container-large">
            <Box className="layout357_sticky-top">
              {layoutProps.showItemNumber && (
                <Box className="margin-right margin-small">
                  <Variants.ParagraphMedium bold>
                    0{_index ? _index + 1 : 1}
                  </Variants.ParagraphMedium>
                </Box>
              )}
              <Variants.ParagraphMedium bold>
                {tabTitle}
              </Variants.ParagraphMedium>
            </Box>
            <Box className="padding-vertical padding-large layout357_content-layout">
              <Box
                sx={{ order: layoutProps.mediaPlacement === "right" ? 0 : 1 }}
                className="layout357_content-left"
              >
                {tagline && (
                  <Box className="margin-bottom margin-xsmall">
                    <Variants.TagLine>{tagline}</Variants.TagLine>
                  </Box>
                )}
                <Box className="margin-bottom margin-small">
                  <Variants.Heading>{title}</Variants.Heading>
                </Box>
                <Variants.ParagraphMedium>
                  {description}
                </Variants.ParagraphMedium>
                {renderSecondaryBlock(SecondaryBlock)}
                {renderTertiaryBlock(TertiaryBlock)}
              </Box>
              <Box className="layout357_image-wrapper">
                <Variants.Image
                  src={image?.url}
                  loading="lazy"
                  alt={image?.alt}
                  className="layout357_image"
                />
              </Box>
            </Box>
          </Box>
        </Variants.GridOddEven>
      </Box>
    );
  }
);

const itemDefaults = {
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0] ?? {},
};
ContentCollectionItem.defaultProps =
  getDefaultProps<ContentCollectionItemType>(itemDefaults);
